import React, { Component } from "react";
import Spinner from "react-bootstrap/Spinner";
import contactAnimationData from "../image/loading.json";
import Lottie from "react-lottie";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: contactAnimationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default class AnimationLoading extends Component {
  render() {
    return (
      <div >
        <Lottie options={defaultOptions} width={200} height={200} />
        {/* <div style={{ zIndex: 2000, alignSelf: 'center', flexDirection: "column", display: "flex", justifyContent: "center", alignItems: "center" }}>
                </div> */}
      </div>
    );
  }
}
